import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ComponentsModule } from '../../components.module';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

@Component({
	selector: 'app-modal-matter-form-instance-viewer',
	templateUrl: './modal-matter-form-instance-viewer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ComponentsModule],
})
export class ModalFormInstanceViewerComponent {
	public form = inject(DRAWER_DATA)?.form;
}
